import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";
import { images } from "../../constants";

import { AppWrap, MotionWrap } from "../../wrapper";
// import { urlFor, client } from '../../client';
import "./Work.scss";

const works_01 = [
  // {
  //   name: "Chair Shop",
  //   imgUrl: `${images.chair_shop}`,
  //   projectLink: "https://st-chairs-shop.netlify.app/",
  //   codeLink: "https://github.com/SameekshThakur/The-Chair-Shop",
  //   title: "UI/UX",
  //   description: "A simple web design prototype for a furniture selling website including navigation features",
  //   tag: "UI/UX"
  // },
  // {
  //   name: "*IN PROGRESS*",
  //   imgUrl: `${images.devstore}`,
  //   projectLink: "",
  //   codeLink: "",
  //   title: "Ecommerce App",
  //   description: "Fashion e-commerce app with headless CMS (Strapi) & Stripe Integration",
  //   tag: "React JS"
  // },
  {
    name: "ToDo App",
    imgUrl: `${images.todo_app}`,
    projectLink: "https://todo-task-manager-list.netlify.app/",
    codeLink: "https://github.com/SameekshThakur/ToDo-List",
    title: "ToDo Application",
    description:
      "Simple ToDo List with CRUD operations built using Vanilla JavaScript",
    tag: "JavaScript App",
  },
  {
    name: "MoviesFlixx",
    imgUrl: `${images.flixx_app}`,
    projectLink: "https://st-flixx-app.vercel.app/",
    codeLink: "https://github.com/SameekshThakur/Flixx-App",
    title: "Flixx App",
    description:
      "This Movie Recommedation app shows users the latest Movies & Tv shows using TMDB API",
    tag: "JavaScript App",
  },
  {
    name: "Omnifood",
    imgUrl: `${images.omnifood_app}`,
    projectLink: "https://st-omnifood-app.netlify.app/",
    codeLink: "https://github.com/SameekshThakur/Omnifood-App",
    title: "Food Servicing App",
    description:
      "Omnifood is a web design of food servicing & delivery app pocessing an engaging User Interface",
    tag: "UI/UX",
  },
];

const Work = () => {
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(() => {
    setWorks(works_01);
    setFilterWork(works_01);
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tag.includes(item)));
      }
    }, 500);
  };

  return (
    <div>
      <h2 className="head-text">
        My Creative <span>Portfolio</span> Section
      </h2>

      <div className="app__work-filter">
        {["UI/UX", "JavaScript App", "All"].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img src={work.imgUrl} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.name}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);

// export default Projects;
